import { jsx as p, jsxs as k } from "react/jsx-runtime";
import * as s from "react";
import { r as ve, u as q, a as z, c as he, e as ye, d as Ee } from "../../index-7nLHFyEB.js";
import { S as K, a as Te } from "../../index-DsTrtXZS.js";
import { u as be, P as Ce } from "../../index-aXeM5VrT.js";
import { c as J, A as we, C as ge, a as Pe, R as xe } from "../../index-n04y80Du.js";
import { cn as Q } from "../../utils.js";
function w(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function V(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Re(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = V(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : V(e[o], null);
        }
      };
  };
}
function O(...e) {
  return s.useCallback(Re(...e), e);
}
var Ne = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], B = Ne.reduce((e, t) => {
  const n = s.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, d = i ? K : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(d, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Oe(e, t) {
  e && ve.flushSync(() => e.dispatchEvent(t));
}
var De = "DismissableLayer", F = "dismissableLayer.update", Ae = "dismissableLayer.pointerDownOutside", Le = "dismissableLayer.focusOutside", Y, Z = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ee = s.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: l,
      onDismiss: d,
      ...u
    } = e, c = s.useContext(Z), [a, v] = s.useState(null), m = (a == null ? void 0 : a.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, f] = s.useState({}), y = O(t, (h) => v(h)), E = Array.from(c.layers), [T] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), C = E.indexOf(T), b = a ? E.indexOf(a) : -1, P = c.layersWithOutsidePointerEventsDisabled.size > 0, g = b >= C, x = Me((h) => {
      const A = h.target, j = [...c.branches].some((I) => I.contains(A));
      !g || j || (o == null || o(h), l == null || l(h), h.defaultPrevented || d == null || d());
    }, m), N = Ie((h) => {
      const A = h.target;
      [...c.branches].some((I) => I.contains(A)) || (i == null || i(h), l == null || l(h), h.defaultPrevented || d == null || d());
    }, m);
    return be((h) => {
      b === c.layers.size - 1 && (r == null || r(h), !h.defaultPrevented && d && (h.preventDefault(), d()));
    }, m), s.useEffect(() => {
      if (a)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Y = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(a)), c.layers.add(a), X(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Y);
        };
    }, [a, m, n, c]), s.useEffect(() => () => {
      a && (c.layers.delete(a), c.layersWithOutsidePointerEventsDisabled.delete(a), X());
    }, [a, c]), s.useEffect(() => {
      const h = () => f({});
      return document.addEventListener(F, h), () => document.removeEventListener(F, h);
    }, []), /* @__PURE__ */ p(
      B.div,
      {
        ...u,
        ref: y,
        style: {
          pointerEvents: P ? g ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: w(e.onFocusCapture, N.onFocusCapture),
        onBlurCapture: w(e.onBlurCapture, N.onBlurCapture),
        onPointerDownCapture: w(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
ee.displayName = De;
var Se = "DismissableLayerBranch", _e = s.forwardRef((e, t) => {
  const n = s.useContext(Z), r = s.useRef(null), o = O(t, r);
  return s.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ p(B.div, { ...e, ref: o });
});
_e.displayName = Se;
function Me(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = q(e), r = s.useRef(!1), o = s.useRef(() => {
  });
  return s.useEffect(() => {
    const i = (d) => {
      if (d.target && !r.current) {
        let u = function() {
          te(
            Ae,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: d };
        d.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, l = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(l), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Ie(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = q(e), r = s.useRef(!1);
  return s.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && te(Le, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function X() {
  const e = new CustomEvent(F);
  document.dispatchEvent(e);
}
function te(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Oe(o, i) : o.dispatchEvent(i);
}
function ke(e, t) {
  return s.useReducer((n, r) => t[n][r] ?? n, e);
}
var H = (e) => {
  const { present: t, children: n } = e, r = Fe(t), o = typeof n == "function" ? n({ present: r.isPresent }) : s.Children.only(n), i = O(r.ref, Ue(o));
  return typeof n == "function" || r.isPresent ? s.cloneElement(o, { ref: i }) : null;
};
H.displayName = "Presence";
function Fe(e) {
  const [t, n] = s.useState(), r = s.useRef({}), o = s.useRef(e), i = s.useRef("none"), l = e ? "mounted" : "unmounted", [d, u] = ke(l, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return s.useEffect(() => {
    const c = L(r.current);
    i.current = d === "mounted" ? c : "none";
  }, [d]), z(() => {
    const c = r.current, a = o.current;
    if (a !== e) {
      const m = i.current, f = L(c);
      e ? u("MOUNT") : f === "none" || (c == null ? void 0 : c.display) === "none" ? u("UNMOUNT") : u(a && m !== f ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), z(() => {
    if (t) {
      let c;
      const a = t.ownerDocument.defaultView ?? window, v = (f) => {
        const E = L(r.current).includes(f.animationName);
        if (f.target === t && E && (u("ANIMATION_END"), !o.current)) {
          const T = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = a.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = T);
          });
        }
      }, m = (f) => {
        f.target === t && (i.current = L(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", v), t.addEventListener("animationend", v), () => {
        a.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", v), t.removeEventListener("animationend", v);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(d),
    ref: s.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function L(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Ue(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var We = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Be = We.reduce((e, t) => {
  const n = s.forwardRef((r, o) => {
    const { asChild: i, ...l } = r, d = i ? K : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(d, { ...l, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), He = "VisuallyHidden", ne = s.forwardRef(
  (e, t) => /* @__PURE__ */ p(
    Be.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
ne.displayName = He;
var $e = ne, [S, Et] = he("Tooltip", [
  J
]), _ = J(), re = "TooltipProvider", Ge = 700, U = "tooltip.open", [je, $] = S(re), oe = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Ge,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [l, d] = s.useState(!0), u = s.useRef(!1), c = s.useRef(0);
  return s.useEffect(() => {
    const a = c.current;
    return () => window.clearTimeout(a);
  }, []), /* @__PURE__ */ p(
    je,
    {
      scope: t,
      isOpenDelayed: l,
      delayDuration: n,
      onOpen: s.useCallback(() => {
        window.clearTimeout(c.current), d(!1);
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => d(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: u,
      onPointerInTransitChange: s.useCallback((a) => {
        u.current = a;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
oe.displayName = re;
var M = "Tooltip", [ze, D] = S(M), se = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: l,
    delayDuration: d
  } = e, u = $(M, e.__scopeTooltip), c = _(t), [a, v] = s.useState(null), m = ye(), f = s.useRef(0), y = l ?? u.disableHoverableContent, E = d ?? u.delayDuration, T = s.useRef(!1), [C = !1, b] = Ee({
    prop: r,
    defaultProp: o,
    onChange: (h) => {
      h ? (u.onOpen(), document.dispatchEvent(new CustomEvent(U))) : u.onClose(), i == null || i(h);
    }
  }), P = s.useMemo(() => C ? T.current ? "delayed-open" : "instant-open" : "closed", [C]), g = s.useCallback(() => {
    window.clearTimeout(f.current), f.current = 0, T.current = !1, b(!0);
  }, [b]), x = s.useCallback(() => {
    window.clearTimeout(f.current), f.current = 0, b(!1);
  }, [b]), N = s.useCallback(() => {
    window.clearTimeout(f.current), f.current = window.setTimeout(() => {
      T.current = !0, b(!0), f.current = 0;
    }, E);
  }, [E, b]);
  return s.useEffect(() => () => {
    f.current && (window.clearTimeout(f.current), f.current = 0);
  }, []), /* @__PURE__ */ p(xe, { ...c, children: /* @__PURE__ */ p(
    ze,
    {
      scope: t,
      contentId: m,
      open: C,
      stateAttribute: P,
      trigger: a,
      onTriggerChange: v,
      onTriggerEnter: s.useCallback(() => {
        u.isOpenDelayed ? N() : g();
      }, [u.isOpenDelayed, N, g]),
      onTriggerLeave: s.useCallback(() => {
        y ? x() : (window.clearTimeout(f.current), f.current = 0);
      }, [x, y]),
      onOpen: g,
      onClose: x,
      disableHoverableContent: y,
      children: n
    }
  ) });
};
se.displayName = M;
var W = "TooltipTrigger", ie = s.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = D(W, n), i = $(W, n), l = _(n), d = s.useRef(null), u = O(t, d, o.onTriggerChange), c = s.useRef(!1), a = s.useRef(!1), v = s.useCallback(() => c.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", v), [v]), /* @__PURE__ */ p(we, { asChild: !0, ...l, children: /* @__PURE__ */ p(
      B.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: u,
        onPointerMove: w(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !a.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), a.current = !0);
        }),
        onPointerLeave: w(e.onPointerLeave, () => {
          o.onTriggerLeave(), a.current = !1;
        }),
        onPointerDown: w(e.onPointerDown, () => {
          c.current = !0, document.addEventListener("pointerup", v, { once: !0 });
        }),
        onFocus: w(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: w(e.onBlur, o.onClose),
        onClick: w(e.onClick, o.onClose)
      }
    ) });
  }
);
ie.displayName = W;
var G = "TooltipPortal", [Ve, Ye] = S(G, {
  forceMount: void 0
}), ae = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, i = D(G, t);
  return /* @__PURE__ */ p(Ve, { scope: t, forceMount: n, children: /* @__PURE__ */ p(H, { present: n || i.open, children: /* @__PURE__ */ p(Ce, { asChild: !0, container: o, children: r }) }) });
};
ae.displayName = G;
var R = "TooltipContent", ce = s.forwardRef(
  (e, t) => {
    const n = Ye(R, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = e, l = D(R, e.__scopeTooltip);
    return /* @__PURE__ */ p(H, { present: r || l.open, children: l.disableHoverableContent ? /* @__PURE__ */ p(le, { side: o, ...i, ref: t }) : /* @__PURE__ */ p(Xe, { side: o, ...i, ref: t }) });
  }
), Xe = s.forwardRef((e, t) => {
  const n = D(R, e.__scopeTooltip), r = $(R, e.__scopeTooltip), o = s.useRef(null), i = O(t, o), [l, d] = s.useState(null), { trigger: u, onClose: c } = n, a = o.current, { onPointerInTransitChange: v } = r, m = s.useCallback(() => {
    d(null), v(!1);
  }, [v]), f = s.useCallback(
    (y, E) => {
      const T = y.currentTarget, C = { x: y.clientX, y: y.clientY }, b = Je(C, T.getBoundingClientRect()), P = Qe(C, b), g = Ze(E.getBoundingClientRect()), x = tt([...P, ...g]);
      d(x), v(!0);
    },
    [v]
  );
  return s.useEffect(() => () => m(), [m]), s.useEffect(() => {
    if (u && a) {
      const y = (T) => f(T, a), E = (T) => f(T, u);
      return u.addEventListener("pointerleave", y), a.addEventListener("pointerleave", E), () => {
        u.removeEventListener("pointerleave", y), a.removeEventListener("pointerleave", E);
      };
    }
  }, [u, a, f, m]), s.useEffect(() => {
    if (l) {
      const y = (E) => {
        const T = E.target, C = { x: E.clientX, y: E.clientY }, b = (u == null ? void 0 : u.contains(T)) || (a == null ? void 0 : a.contains(T)), P = !et(C, l);
        b ? m() : P && (m(), c());
      };
      return document.addEventListener("pointermove", y), () => document.removeEventListener("pointermove", y);
    }
  }, [u, a, l, c, m]), /* @__PURE__ */ p(le, { ...e, ref: i });
}), [qe, Ke] = S(M, { isInside: !1 }), le = s.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      ...d
    } = e, u = D(R, n), c = _(n), { onClose: a } = u;
    return s.useEffect(() => (document.addEventListener(U, a), () => document.removeEventListener(U, a)), [a]), s.useEffect(() => {
      if (u.trigger) {
        const v = (m) => {
          const f = m.target;
          f != null && f.contains(u.trigger) && a();
        };
        return window.addEventListener("scroll", v, { capture: !0 }), () => window.removeEventListener("scroll", v, { capture: !0 });
      }
    }, [u.trigger, a]), /* @__PURE__ */ p(
      ee,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: l,
        onFocusOutside: (v) => v.preventDefault(),
        onDismiss: a,
        children: /* @__PURE__ */ k(
          ge,
          {
            "data-state": u.stateAttribute,
            ...c,
            ...d,
            ref: t,
            style: {
              ...d.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ p(Te, { children: r }),
              /* @__PURE__ */ p(qe, { scope: n, isInside: !0, children: /* @__PURE__ */ p($e, { id: u.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
ce.displayName = R;
var ue = "TooltipArrow", de = s.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = _(n);
    return Ke(
      ue,
      n
    ).isInside ? null : /* @__PURE__ */ p(Pe, { ...o, ...r, ref: t });
  }
);
de.displayName = ue;
function Je(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Qe(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function Ze(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function et(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, l = t.length - 1; i < t.length; l = i++) {
    const d = t[i].x, u = t[i].y, c = t[l].x, a = t[l].y;
    u > r != a > r && n < (c - d) * (r - u) / (a - u) + d && (o = !o);
  }
  return o;
}
function tt(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), nt(t);
}
function nt(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], l = t[t.length - 2];
      if ((i.x - l.x) * (o.y - l.y) >= (i.y - l.y) * (o.x - l.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], l = n[n.length - 2];
      if ((i.x - l.x) * (o.y - l.y) >= (i.y - l.y) * (o.x - l.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var rt = oe, ot = se, st = ie, fe = ae, pe = ce, it = de;
const at = rt, ct = ot, lt = st, ut = fe, dt = it, me = s.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ p(fe, { children: /* @__PURE__ */ p(
  pe,
  {
    ref: r,
    sideOffset: t,
    className: Q(
      "z-50 overflow-hidden rounded bg-neutral-30 text-white p-4 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:bg-gray-50 dark:text-gray-900",
      e
    ),
    ...n
  }
) }));
me.displayName = pe.displayName;
const Tt = ({
  children: e,
  defaultOpen: t,
  delayDuration: n = 100,
  message: r,
  tooltipContentProps: o,
  onOpenChange: i,
  disableHoverableContent: l,
  tooltipTriggerProps: d
}) => /* @__PURE__ */ p(at, { children: /* @__PURE__ */ k(
  ct,
  {
    defaultOpen: t,
    onOpenChange: i,
    delayDuration: n,
    disableHoverableContent: l,
    children: [
      /* @__PURE__ */ p(
        lt,
        {
          type: "button",
          className: Q("flex items-start", d == null ? void 0 : d.className),
          ...d,
          children: e
        }
      ),
      /* @__PURE__ */ p(ut, { children: /* @__PURE__ */ k(
        me,
        {
          side: "top",
          align: "start",
          sideOffset: 4,
          className: "max-w-[280px]",
          ...o,
          children: [
            r,
            /* @__PURE__ */ p(dt, { className: "fill-neutral-30 w-5 h-[10px]" })
          ]
        }
      ) })
    ]
  }
) });
export {
  Tt as Tooltip
};
